var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoCell"},[_c('div',{staticClass:"left"},[_c('yx-avatar',{attrs:{"src":_vm.row.avatar_url}})],1),_c('div',{staticClass:"right ml-10"},[_c('p',{staticClass:"yx-color-text-primary fz-14"},[_vm._v(_vm._s(_vm.row.nick_name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }